var AriesComponent = require('./aries-component');

var PostalAddressBase = AriesComponent.extend({
  unBindEvents: function($) {
    $('[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  },
  isFreshLoad: function() {
    this.defObj.addressSection = this.$el.find('#js-form-address');
    this.defObj.inLanguage = this.defObj.addressSection.data('inlanguage');
    this.defObj.siteId = this.defObj.addressSection.data('siteid');
    this.defObj.postal = this.$el.find('#postal-field');
    this.defObj.zipRequiredCountry = this.defObj.addressSection.data('zip-required');
    this.defObj.postalRequiredCountry = this.defObj.addressSection.data('postal-required');
    this.defObj.formError = '<i class="icon icon-error t-form-error"></i><span class="is-hidden-text">Error: Required Field</span>';
    this.defObj.formAsterisk = '<i class="icon icon-asterisk t-form-asterisk"></i><span class="is-hidden-text">Required Field</span>';
    this.defObj.postalfield = this.defObj.addressSection.find('.address-zipcode');
    },
  addressOrder: function(country) {
    var address = this.$el.find('#dynamic-address');
    var addressObj = {
      address: address,
      street: address.find('#fieldset-street'),
      city: address.find('#fieldset-city'),
      state: address.find('#fieldset-state'),
      postal: address.find('#fieldset-postal'),
      addressOrder: (country === 'CN') ? ['state', 'city', 'postal', 'street'] : ['street', 'city', 'state', 'postal'],
      splitEnd: this.$el.find('input#splitEndClass').val(),
      statePlacement: 0,
      postalPlacement: 0
    };
    addressObj.address.empty();
    addressObj.postal.removeClass(addressObj.splitEnd);
    addressObj.state.removeClass(addressObj.splitEnd);
    this.addressOrderSubMethod(addressObj);
  },
  addressOrderSubMethod: function(addressObj) {
    var matchString = ['street', 'city', 'state', 'postal'];
    var element = '',
    addressOrderLength = addressObj.addressOrder.length;
    for (var i = 0; i < addressOrderLength; i++) {
      element = addressObj.addressOrder[i];
      if (matchString.indexOf(element) > -1) {
        addressObj.address.append(addressObj[element]);
      }
      if (element === 'state') {
        addressObj.statePlacement = i;
      } else if (element === 'postal') {
        addressObj.postalPlacement = i;
      }
    }
    this.checkStatePostal(addressObj);
  },
  checkStatePostal: function(addressObj) {
    if (addressObj.state.length > 0 && addressObj.postal.length > 0) {
      if ((addressObj.statePlacement - 1) === addressObj.postalPlacement) {
        addressObj.state.addClass(addressObj.splitEnd);
      } else if ((addressObj.postalPlacement - 1) === addressObj.statePlacement) {
        addressObj.postal.addClass(addressObj.splitEnd);
      }
    }
  },
  addressDisplay: function(country) {
    if (!((this.defObj.inLanguage === 'true' || this.defObj.inLanguage === true) && this.defObj.siteId === 'CN')) {
      this.postalLabelDisplay(country);
    }
  },
  postalLabelDisplay: function(country) {
    if (this.defObj.postal.length) {
      var postalLabel = this.defObj.postal.find('label').first();
      var postalData = postalLabel.data('properties');

      if (postalData !== undefined) {
        this.postalLabelDisplaySubMethod(postalLabel, postalData, country);
      }
    }
  },
  postalLabelDisplaySubMethod: function(postalLabel, postalData, country) {
    var postalInput = this.defObj.postal.find('#field-postal');
    var postalDataVar;
    if (postalLabel) {
      this.defObj.postalfield.show();
    }
    postalInput.show();
    if (country && this.defObj.zipRequiredCountry.indexOf(country) !== -1) {
      postalDataVar = (postalLabel.find('.icon-error').first().length) ? this.defObj.formError : "";
      postalLabel.empty().html(postalDataVar + postalData.zipLabel);
    } else if (country && this.defObj.postalRequiredCountry.indexOf(country) !== -1) {
      postalDataVar = (postalLabel.find('.icon-error').first().length) ? this.defObj.formError : "";
      postalLabel.empty().html(postalDataVar + postalData.postalLabel);
    } else {
      postalLabel.empty().text(postalData.zipPostalLabel);
      postalInput.removeClass('is-error').hide().val('');
      if (postalLabel) {
        this.defObj.postalfield.hide();
      }
    }
  },
  bindChangeEvent: function($) {
    var _self = this;
    $("#field-country").on('change', function() {
      var selectedVal = $(this).val();
      if (selectedVal.length > 0) {
        _self.addressOrder(selectedVal);
        _self.addressDisplay(selectedVal);
      }
    });
  },
  bindPostalAddressBase: function() {
    var _self = this;
    _self.isFreshLoad();
    if (_self.defObj.addressSection.length && _self.$el.find('#field-country').length) {
      var countryVal = _self.$el.find('#field-country').val();

      if (countryVal) {
        _self.addressOrder(countryVal);
        _self.addressDisplay(countryVal);
      } else if (_self.defObj.siteId) {
        _self.addressOrder(_self.defObj.siteId);
      }
    }
  }
});

module.exports = PostalAddressBase;
